import translate from "@insite/client-framework/Translate";
import DataTable from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import Radio from "@insite/mobius/Radio";
import RadioGroup from "@insite/mobius/RadioGroup";
import { BillToSelectionStylesStyles } from "@store/Components/Customer/BillToSelection";

import React from "react";

interface OwnProps {
    currentItems: Array<object>;
    styles: BillToSelectionStylesStyles;
    currentShipTo: string;
    selectCustomerHandler: Function;
    isShipTo: boolean;
}

const CustomerTable = ({ currentItems, styles, currentShipTo, selectCustomerHandler, isShipTo }: OwnProps) => {
    return (
        <DataTable {...styles.table}>
            <DataTableHead {...styles.tableHead}>
                <DataTableHeader {...styles.radioRowHeader}></DataTableHeader>
                <DataTableHeader {...styles.idRowHeader}>{translate("Id")}</DataTableHeader>
                <DataTableHeader {...styles.customerTableColHeader}>{translate("Customer")}</DataTableHeader>
                <DataTableHeader {...styles.addressTableColHeader}>{translate("Address")}</DataTableHeader>
                <DataTableHeader {...styles.cityTableColheader}>{translate("City")}</DataTableHeader>
            </DataTableHead>
            <DataTableBody {...styles.selectorDynamicDropdown}>
                {currentItems.map(({ id, address1, customerNumber, customerName, city, customerSequence }: any) => (
                    <DataTableRow
                        className={currentShipTo === id ? "is-selected" : ""}
                        onClick={() => selectCustomerHandler(id)}
                        key={id}
                        {...styles.customerRow}
                    >
                        <DataTableCell>
                            <RadioGroup value={currentShipTo}>
                                <Radio value={id}></Radio>
                            </RadioGroup>
                        </DataTableCell>
                        <DataTableCell>{isShipTo ? customerSequence : customerNumber}</DataTableCell>
                        <DataTableCell>{customerName}</DataTableCell>
                        <DataTableCell>{address1}</DataTableCell>
                        <DataTableCell>{city}</DataTableCell>
                    </DataTableRow>
                ))}
            </DataTableBody>
        </DataTable>
    );
};

export default CustomerTable;
